<dl role="presentation" class="accordion-group">
  <div class="accordion" [ngClass] ="{ 'filled': filled }">
    <ng-content></ng-content>
  </div>
</dl>

